import sdl from '@jds/react-generated-sdl/JDSFooterLinksGrid';
import type { JDSFooterLinksGridProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFooterLinksGridProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSFooterLinksGrid',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FooterLinksGrid = withLogic(
  Component
) as React.FC<JDSFooterLinksGridProps> & { slotName?: string };

FooterLinksGrid.displayName = 'FooterLinksGrid';
FooterLinksGrid.slotName = 'jds_footer_links_grid';

export { FooterLinksGrid, type JDSFooterLinksGridProps };
